<template>
  <div class="page-container">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "PageContainer"
  }
</script>

<style lang="scss" scoped>
  .page-container {
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
    border-radius: 24px;
    padding: 24px;
    width: 100%;
    max-width: 1100px;
    margin-left: auto;
    margin-right: auto;
    flex-grow: 1;
  }
</style>

<style lang="scss">
  .page-container .subtitle {
    font-size: 14px;
    color: var(--primary-color);
    font-weight: bold;
  }
</style>